export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          联系投稿
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          欢迎韩国漫画爱好者、网站运营者与我们联系交流
        </p>
        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100/80 flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-primary-600"></i>
                </div>
                <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1">投稿邮箱</h3>
                <p className="text-foreground-500 text-xs">contact@koreacomics.site</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100/80 flex items-center justify-center">
                  <i className="ri-links-line text-xl text-accent-600"></i>
                </div>
                <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1">网站收录</h3>
                <p className="text-foreground-500 text-xs">提交您的韩国漫画网站</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100/80 flex items-center justify-center">
                  <i className="ri-chat-3-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1">合作咨询</h3>
                <p className="text-foreground-500 text-xs">商务合作与广告投放</p>
              </div>
            </div>
            <div className="mt-8 pt-6 border-t border-background-200/70">
              <p className="text-foreground-500 text-xs text-center leading-relaxed">
                如果您运营韩国漫画网站并希望被本站收录，或是有任何关于韩国漫画网站推荐、排行的建议，欢迎随时联系我们。我们期待与更多韩国漫画网运营者和爱好者建立联系，共同打造更完善的韩国漫画网站大全。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}